import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-report_dark",
  "use": "icon-report_dark-usage",
  "viewBox": "0 0 42 36",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 42 36\" id=\"icon-report_dark\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M-1-4.4h44v44H-1z\" /><path d=\"M31.083.183 41.167 17.6 31.083 35.017H10.917L.833 17.6 10.917.183h20.166ZM28.97 3.85H13.03L5.07 17.6l7.96 13.75h15.94l7.96-13.75-7.96-13.75ZM19.166 23.1h3.666v3.667h-3.666V23.1Zm0-14.667h3.666v11h-3.666v-11Z\" fill=\"#333\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol